import { render } from "./UpdateAllocationModal.vue?vue&type=template&id=37899d28&scoped=true"
import script from "./UpdateAllocationModal.vue?vue&type=script&lang=js"
export * from "./UpdateAllocationModal.vue?vue&type=script&lang=js"

import "./UpdateAllocationModal.vue?vue&type=style&index=0&id=37899d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37899d28"]])

export default __exports__